<template>
  <div class="space-y-5">
    <div class="flex items-center justify-between">
      <div>
        <h2 class="text-lg font-bold text-neutral-900">我的智能体</h2>
        <p class="text-xs text-neutral-400 mt-0.5">
          你创建的知识库智能体与外部嵌入智能体
        </p>
      </div>
      <router-link
        to="/knowledge?create=1"
        class="text-sm text-primary hover:underline font-medium"
      >
        <i class="fa fa-plus mr-1"></i>创建智能体
      </router-link>
    </div>

    <div v-if="loading" class="py-12 text-center text-neutral-400">
      <i class="fa fa-circle-o-notch fa-spin text-xl"></i>
    </div>

    <div v-else-if="!list.length" class="bg-white rounded-xl border border-neutral-200 p-12 text-center">
      <div
        class="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mx-auto mb-4 text-neutral-400"
      >
        <i class="fa fa-robot text-2xl"></i>
      </div>
      <h3 class="text-lg font-medium text-neutral-900 mb-2">还没有创建智能体</h3>
      <p class="text-neutral-500 text-sm mb-6">
        上传教案资料、选一个模型，就能得到一个懂你学科的助手。
      </p>
      <router-link
        to="/knowledge?create=1"
        class="inline-block px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 text-sm font-medium"
      >
        去创建
      </router-link>
    </div>

    <div v-else class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
      <div
        v-for="a in list"
        :key="a.id"
        class="bg-white rounded-xl border border-neutral-200 p-4 hover:shadow-md hover:border-primary/40 transition-all cursor-pointer flex flex-col"
        @click="open"
      >
        <div class="flex items-start gap-3 mb-2">
          <div
            class="w-11 h-11 rounded-xl flex items-center justify-center text-white font-bold flex-shrink-0 overflow-hidden"
            :style="{ background: colorOf(a.id) }"
          >
            <img v-if="a.avatar" :src="a.avatar" class="w-full h-full object-cover" alt="" />
            <span v-else>{{ (a.name || "智")[0] }}</span>
          </div>
          <div class="min-w-0 flex-1">
            <h3 class="font-semibold text-sm text-neutral-900 truncate">{{ a.name }}</h3>
            <span
              class="text-[11px] px-2 py-0.5 rounded-full"
              :class="
                a.mode === 'embed'
                  ? 'bg-sky-50 text-sky-600'
                  : 'bg-emerald-50 text-emerald-600'
              "
            >
              {{ a.mode === "embed" ? "外部嵌入" : "自建知识库" }}
            </span>
          </div>
        </div>
        <p class="text-xs text-neutral-500 line-clamp-2 flex-1 min-h-[2.2rem] mb-2">
          {{ a.intro || "暂无简介" }}
        </p>
        <div class="flex items-center justify-between text-[11px] text-neutral-400 pt-2 border-t border-neutral-100">
          <span>
            <template v-if="a.mode === 'kb'">
              <i class="fa fa-file-text-o mr-1"></i>{{ a.docCount || 0 }} 篇
              <i class="fa fa-link ml-2 mr-1"></i>{{ a.linkCount || 0 }}
            </template>
            <template v-else>嵌入页面</template>
          </span>
          <span>{{ a.isPublic ? "已公开" : "私有" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyAgentPanel",
  data() {
    return {
      loading: false,
      list: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      if (!localStorage.getItem("token")) return;
      this.loading = true;
      try {
        const res = await this.$axios({
          url: "user/agent/mine",
          method: "POST",
          data: { data: await this.$aesEncrypt({}) },
        });
        if (res.code === 200 && res.data) {
          this.list = res.data.list || [];
        }
      } catch (e) {
        /* ignore */
      }
      this.loading = false;
    },
    open() {
      this.$router.push("/knowledge");
    },
    colorOf(id) {
      const palette = ["#6366f1", "#0ea5e9", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6", "#14b8a6"];
      let h = 0;
      const s = String(id || "");
      for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) % 9973;
      return palette[h % palette.length];
    },
  },
};
</script>
